export interface IUser {
  IsLoggedInUser: boolean;
}

export interface IProduct {
  ProductCode: string;
}

export interface IOptInNotification {
  Email: string;
  UserName: string;
  IsLoggedInUser: boolean;
  ProductCode: string;
}

export const UserDetails: IUser = {
  IsLoggedInUser: false,
};

export const ProductDetails: IProduct = {
  ProductCode: 'Std 650',
};

export const OptInNotificationDetails: IOptInNotification = {
  Email: '',
  UserName: '',
  IsLoggedInUser: false,
  ProductCode: 'Std 650',
};

export default { OptInNotificationDetails, ProductDetails, UserDetails };
